/**
 * i18n 적용 모듈
 * @module app/i18n
 * @author Olive
 */
import { init, use } from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';

import ko from '@/shared/locales/ko/translation.json';
import en from '@/shared/locales/en/translation.json';

/**
 * 브라우저의 설정을 읽어오는 Detector의 Options을 설정한다.
 */
const detectorOptions = {
  // 브라우저의 설정만을 읽도록 지정한다.
  order: ['navigator'],
  // cache를 지정해두지 않음 (default: localStorage에 저장되어 사용자의 정보가 남아있음)
  caches: [],
};

/**
 * i18n을 적용하기 위해 초기화합니다.
 * @author Olive
 */
use(I18nextBrowserLanguageDetector);
use(initReactI18next);
init({
  detection: detectorOptions,
  resources: {
    ko: {
      translation: ko,
    },
    en: {
      translation: en,
    },
  },
  fallbackLng: 'ko', // 없는 언어일 경우 대체
  interpolation: {
    escapeValue: false, // React는 자동으로 escaping 처리함
  },
  debug: true,
});
